import { recursos } from '@/content/site'
import { Icon } from '@/components/Icon'
import styles from './Recursos.module.css'

export function Recursos() {
  return (
    <section id="recursos" className="section">
      <div className="container">
        <header className={`${styles.head} reveal`}>
          <p className="eyebrow">Recursos</p>
          <h2 className="section-title">Herramientas para avanzar</h2>
          <p className="section-lead">
            Una biblioteca de contenido útil y descargable para entregar valor desde el primer día.
          </p>
        </header>

        <div className={styles.grid}>
          {recursos.map((r) => (
            <article key={r.title} className={`${styles.card} reveal`}>
              <div className={styles.icon}>
                <Icon name="arrow-up-right" size={20} />
              </div>
              <h3 className={styles.title}>{r.title}</h3>
              <p className={styles.text}>{r.text}</p>
            </article>
          ))}
        </div>

        <div className={`${styles.cta} reveal`}>
          <a href="#contacto" className="btn btn--primary btn--lg">
            Descargar recursos
          </a>
          <p className={styles.note}>
            Próximamente algunos recursos se entregarán mediante registro de correo, siempre con
            información clara sobre el uso de tus datos.
          </p>
        </div>
      </div>
    </section>
  )
}
